import { TextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

type BaseInputProps = TextFieldProps;

const BaseInput = styled(TextField)<BaseInputProps>(({ theme }) => ({}));

export default BaseInput;
